






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storeUnit } from "@/store/modules/unit";

interface AutocompleteOptions {
  outlined: true;
  label: "";
}

@Component({
  components: {}
})
export default class UnitAutoComplete extends Vue {
  @Prop() setUnit!: object;

  @Prop({
    default: () => {
      return {
        outlined: true,
        label: null
      };
    }
  })
  opt: AutocompleteOptions;

  get listUnit() {
    return storeUnit.unitPagi;
  }

  unit = {};

  list = [];

  searchUnit = null;

  loading = false;

  @Watch("setUnit")
  valUnit(val) {
    this.$emit("unit", val);
  }
}
